import { Helmet } from 'react-helmet';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, HelpInfo, Typography } from 'components';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import TriangleIcon from 'assets/icons/yellow-warning.svg?react';
import useAuth from 'utils/auth';
import { useKeycloakStore } from 'hooks/zustandStore';
import { useLegacyLoginAuth } from 'hooks/webapi';
import styles from './RejectedOffer.module.scss';

export default function RejectedOffer() {
  const { t } = useTranslation(['rejected_offer', 'help_info']);
  const [pending, setPending] = useState(false);
  const { keycloakLogout } = useAuth();

  const { logout: LEGACY_LOGIN_logout } = useLegacyLoginAuth();

  const isLegacyLogin = useKeycloakStore((state) => state.isLegacyLogin);
  const isLegacyLoginLoading = useKeycloakStore(
    (state) => state.isLegacyLoginLoading,
  );

  const handleLegacyLoginLogout = async () => {
    await LEGACY_LOGIN_logout();
    window.location.assign(import.meta.env.VITE_HOMEPAGE_URL);
  };

  const handleKeycloakLogout = useCallback(async () => {
    setPending(true);
    const callbackUrl = import.meta.env.VITE_HOMEPAGE_URL;

    keycloakLogout(callbackUrl);
  }, []);

  const isAuthModeResolving = isLegacyLoginLoading || isLegacyLogin === null;

  const handleLogout = async () => {
    if (isAuthModeResolving) return;

    if (isLegacyLogin) {
      await handleLegacyLoginLogout();
      return;
    }

    await handleKeycloakLogout();
  };

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <CardWithIcon
        icon={<TriangleIcon data-test="rejectedOffer-triangle-icon" />}
        heading={
          <Typography kind="h1" size="l" dataTest="rejectedOffer-title">
            {t('title')}
          </Typography>
        }
        centered={false}
        className="border-0 md:border rounded-none lg:rounded-lg"
        dataTest="rejectedOffer-card"
      >
        <Typography
          fontWeight={700}
          size="m"
          className="text-center lg:text-left"
          dataTest="rejectedOffer-title"
        >
          {t('sub_title')}
        </Typography>

        <Button
          dataTest="redirect-to-root"
          onClick={handleLogout}
          className={styles.button}
          pending={pending || isAuthModeResolving}
        >
          {t('button')}
        </Button>
      </CardWithIcon>

      <div className={styles.help}>
        <HelpInfo title={t('help_info:title')} text={t('help_info:text')} />
      </div>
    </>
  );
}
